
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";
    import { Message } from "element-ui";
    import filters from '@/utils/filters'

    @Component({
        name: "list",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config
        // 表格数据
        tableData = [];
        // 加载状态
        loading = false;
        // 总条数
        total = 0;
        // 搜索条件
        search = {
            keyword: '',
            status: '',
            org_type: '',
            bond_type: '',
            provinces: '',
            city: '',
            pagination: {
                page: 0, //页码，从0开始
                pageSize: 10, //每页数量
            },
        };

        // 获取经理信息
        getMobile(row: any) {
            let arr: any = []
            if(row) {
                row.split(',').forEach((item: any) => {
                    this.customList.forEach((it: any) => {
                        if(item == it.id) {
                            arr.push({
                                name: it.realname,
                                mobile: it.mobile
                            })
                        }
                    })
                })
            }

            return arr
        }

        // 地区选择
        casValue: any = [];
        tag: any = -1; // 标识符（重要）
        disabledLastLevel = false
        filteredOptions = [] // 过滤后的选项数据
        // 省市区
        qhdm = []
        getQhdm() {
            api.getQhdm({}).then(res => {
                // 检查选项数据是否有效
                // 检查选项数据是否有效
                let filteredOptions: any
                if (res && res.length > 0) {
                    filteredOptions = res.map((province: any) => {
                        if (province.children && province.children.length > 0) {
                            let filteredCities: any
                            if(province.children) {
                                filteredCities = province.children.map((city: any) => {
                                    // 过滤掉区级选项
                                    return {
                                        id: city.id,
                                        level_type: city.level_type,
                                        name: city.name,
                                        parent_id: city.parent_id,
                                    };
                                });
                            }

                            return {
                                ...province,
                                children: filteredCities
                            };
                        } else {
                            return province;
                        }
                    });
                }
                this.qhdm = filteredOptions
            })
        }
        changeQY2(item: any) {
            if(item.length == 0) {
                this.casValue = []
                this.tag = -1
                return
            }
            this.search.provinces = item[0]
            this.search.city = item[1]
            let isGo = false;
            let _tag = 0;
            item.forEach((i: any) => {
                if (i[0] != this.tag) {
                    isGo = true;
                    _tag = i[0];
                }
            });
            if (isGo) {
                let filterd = item.filter((v: any) => v[0] != this.tag);
                this.tag = _tag;
                this.casValue = filterd;
            }
        }

        // 上架
        shangxiajia(row: any) {
            this.$confirm('将更改该产品的状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.post('A4014', {id: row.id}).then(res => {
                    this.searchTable()
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                })

            }).catch(() => {});
        }


        // 新建产品
        addDialog = false
        btnloading = false
        ruleForm: any = {
            name: '',
            bond_type: '',
            org_type: '',
            prefix_code: '',
            project_type: ''
        }
        save() {
            if(!this.ruleForm.name) {
                this.$message.warning('请输入产品名称')
                return
            }
            if(!this.ruleForm.bond_type) {
                this.$message.warning('请选择产品种类')
                return
            }
            if(!this.ruleForm.org_type) {
                this.$message.warning('请选择保函种类')
                return
            }
            if(!this.ruleForm.prefix_code) {
                this.$message.warning('请输入编号前缀')
                return
            }
            this.btnloading = true;
            api.post('A4002', this.ruleForm).then(res => {
                this.$message.success('操作成功')
                this.addDialog = false
                this.searchTable()
            }).finally(() => {
                this.btnloading = false
            })
        }
        cancle() {
            this.addDialog = false;
        }

        add() {
            this.ruleForm = {
                name: '',
                bond_type: '',
                org_type: ''
            }
            this.addDialog = true
        }

        // 详情
        // 查看
        isDialog = false;
        list: any = [];
        detailInfo = {}
        toDetail(res: any) {
            this.detailInfo = res
            this.isDialog = true;
        }

        //配置
        toConfig(row: any) {
            this.$router.push({
                path: '/product/productConfig',
                query: {
                    id: row.id,
                    channel_type: row.channel_type,
                    channel_id: row.channel_id,
                    bond_type: row.bond_type,
                    op_id:row.op_id,
                    org_id: row.org_id
                }
            })
        }

        // 搜索 search:true 重置翻页
        customList: any = []
        searchTable(search = false) {
            this.loading = true;
            if (search) {
                this.search.pagination = {
                    pageSize: 20,
                    page: 0,
                };
            }
            api
                .post("A4001", this.search)
                .then((data: any) => {
                    this.total = data.total;
                    this.tableData = data.list;
                    this.customList = data.custom_list
                })
                .finally(() => {
                    this.loading = false;
                });
        }

        activated() {
            this.searchTable();
            this.getQhdm()
        }
    }
